export const LOGIN_REDIRECT_STORAGE_KEY = 'login_redirect_to';

export function setLoginRedirectTo(redirectTo) {
  localStorage.setItem(LOGIN_REDIRECT_STORAGE_KEY, redirectTo);
}

export function consumeLoginRedirectTo() {
  const redirectTo = localStorage.getItem(LOGIN_REDIRECT_STORAGE_KEY);
  localStorage.removeItem(LOGIN_REDIRECT_STORAGE_KEY);
  return redirectTo;
}
